import { render } from "./AppFeed.vue?vue&type=template&id=e8e838be&scoped=true"
import script from "./AppFeed.vue?vue&type=script&lang=js"
export * from "./AppFeed.vue?vue&type=script&lang=js"

import "./AppFeed.vue?vue&type=style&index=0&id=e8e838be&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b7c0161fc3875e000d6ad7ba26fe3ce3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8e838be"]])

export default __exports__